export const fontSize = {
    h1: '4rem',
    h2: '3rem',
    h3: '2rem',
    h4: '1.25rem',
    prose: '1rem',
};
